<form *ngIf="formGroup" [formGroup]="formGroup">
	<app-form-field [type]="fields.name.type" [options]="fields.name.options"></app-form-field>
	<app-form-field [type]="fields.legal_name.type" [options]="fields.legal_name.options"></app-form-field>
	<app-form-field [type]="fields.client_id.type" [options]="fields.client_id.options"></app-form-field>
	<app-form-field [type]="fields.company_client_id.type" [options]="fields.company_client_id.options"></app-form-field>
	<app-form-field [type]="fields.email.type" [options]="fields.email.options"></app-form-field>

	<app-form-field [type]="fields.tax_id.type" [options]="fields.tax_id.options"></app-form-field>
	<app-form-field [type]="fields.contact_name.type" [options]="fields.contact_name.options"></app-form-field>
	<app-form-field [type]="fields.address.type" [options]="fields.address.options"></app-form-field>
	<app-form-field [type]="fields.phone_number.type" [options]="fields.phone_number.options"></app-form-field>
	<app-form-field [type]="fields.notes.type" [options]="fields.notes.options"></app-form-field>
	<app-form-field [type]="fields.active.type" [options]="fields.active.options"></app-form-field>

	<div class="modal-footer">
		<button class="btn btn-success" (click)="submit()"><i class="fa fa-save"></i> Guardar</button>
		<button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
	</div>
</form>
